import styled from 'styled-components'
import Markdown from '../Markdown'

const MediaDescription = styled(Markdown)`
  color: #333;
  margin-top: 0;
`

export default MediaDescription
